// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faHamburger } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const Burger: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faHamburger} />
//     </Graphics>
//     <Description>
//       This could buy you: <br /> <span>up to 491 Big Mac meals</span>!
//     </Description>
//   </Fragment>
// );

// export default Burger;
